import Lottie from 'react-lottie';
import loadingAnimationData from '../../animations/loading.json';

export const LoadingInline = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return <Lottie data-cy="loading" height={240} width={240} options={defaultOptions} />;
};
